import React from 'react'
import { Form, Input, Row, Col } from 'antd'
import { reglaMedidaRequerida } from '../utils/formUtils'

/**
 * Sección de medidas del formulario
 * Si ocultarMedidasPrincipales es true (porque existe json_medidas), no se muestran Largo/Ancho/Alto/Diámetro mayor
 */
const MedidasSection = ({
  form,
  nombreBascula,
  basculaConectada,
  isReadOnly,
  camposFaltantes,
  getFieldValidation,
  onCampoChange,
  ocultarMedidasPrincipales = false,
  medidaActiva = null,
  onMeasureFocus,
}) => {
  const indicadorConexion = (field) => {
    const activo = medidaActiva === field
    const conectado = basculaConectada && activo
    return (
      <span
        style={{
          display: 'inline-block',
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: conectado ? '#52c41a' : '#ff4d4f',
          marginLeft: 4,
        }}
        title={conectado ? 'Este campo recibe datos del socket' : basculaConectada ? 'Haz clic en el campo para recibir la medida' : 'Socket no conectado'}
      />
    )
  }

  return (
    <Row gutter={6}>
        <>
          <Col span={12}>
            <Form.Item 
              label="Largo mayor" 
              name="largo"
              rules={reglaMedidaRequerida}
              {...getFieldValidation('largo')}
            >
              <Input 
                type="number" 
                placeholder="0"
                disabled={isReadOnly}
                onFocus={() => onMeasureFocus?.('largo')}
                onChange={() => onCampoChange('largo')}
                suffix={indicadorConexion('largo')}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item 
              label="Ancho mayor" 
              name="ancho"
              rules={reglaMedidaRequerida}
              {...getFieldValidation('ancho')}
            >
              <Input 
                type="number" 
                placeholder="0"
                disabled={isReadOnly}
                onFocus={() => onMeasureFocus?.('ancho')}
                onChange={() => onCampoChange('ancho')}
                suffix={indicadorConexion('ancho')}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item 
              label="Alto mayor" 
              name="alto"
              rules={reglaMedidaRequerida}
              {...getFieldValidation('alto')}
            >
              <Input 
                type="number" 
                placeholder="0"
                disabled={isReadOnly}
                onFocus={() => onMeasureFocus?.('alto')}
                onChange={() => onCampoChange('alto')}
                suffix={indicadorConexion('alto')}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item 
              label="Diámetro mayor" 
              name="diametro"
              {...getFieldValidation('diametro')}
            >
              <Input 
                type="number" 
                placeholder="0"
                disabled={isReadOnly}
                onFocus={() => onMeasureFocus?.('diametro')}
                onChange={() => onCampoChange('diametro')}
                suffix={indicadorConexion('diametro')}
              />
            </Form.Item>
          </Col>
        </>
      <Col span={12}>
        <Form.Item 
          label={
            <span>
              Peso (g)
              {nombreBascula && (
                <span style={{ color: '#888', fontSize: '12px', fontWeight: 'normal', marginLeft: '8px' }}>
                  | {nombreBascula}
                </span>
              )}
            </span>
          }
          name="peso"
          rules={reglaMedidaRequerida}
          {...getFieldValidation('peso')}
        >
          <Input 
            type="number" 
            placeholder="0"
            
            disabled={isReadOnly}
            onChange={() => onCampoChange('peso')}
            suffix={
              <span
                style={{
                  display: 'inline-block',
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  backgroundColor: basculaConectada ? '#52c41a' : '#ff4d4f',
                  marginLeft: '4px',
                }}
                title={basculaConectada ? 'Báscula conectada' : 'Báscula desconectada'}
              />
            }
          />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item 
          label="Composición Producto" 
          name="composicion"
          {...getFieldValidation('composicion')}
        >
          <Input
            placeholder="Ingrese composición"
            disabled={isReadOnly}
            onChange={(e) => {
              form.setFieldsValue({
                composicion: e.target.value.toUpperCase(),
              })
              onCampoChange('composicion')
            }}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}

export default MedidasSection
